module.exports = __webpack_public_path__ + "img/sponsor_16.b42961be.png";